<template>
  <b-overlay :show="guilds === null" rounded="sm">
    <div v-if="guilds !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1 class="mb-2">لیست دسته بندی اصناف</h1>
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-button
                variant="primary"
                @click="addNewCategory = !addNewCategory"
              >
                <span class="text-nowrap">+ ساخت صنف جدید</span>
              </b-button>
            </b-col>
            <!--   new Guild name  -->
            <transition name="fade">
              <b-col
                v-if="addNewCategory"
                cols="12"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1"
              >
                <b-col md="8">
                  <div class="form-label-group">
                    <b-form-input
                      class="mb-2"
                      id="name"
                      placeholder="نام صنف"
                      v-model="defaultCreateData.name"
                    />
                  </div>
                </b-col>
                <b-col md="2" class="mb-1">
                  <b-button @click="createAGuild" variant="success">
                    <span class="text-nowrap">ساخت</span>
                  </b-button>
                </b-col>
              </b-col>
            </transition>
          </b-row>
        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="guilds"
          responsive
          :fields="myTableColumns"
          primary-key="id"
          show-empty
          bordered
          striped
          empty-text="موردی موجود نیست!"
        >
          <!-- Column: delete -->

          <template #cell(delete)="data">
            <div
              v-if="data.item.type == 2"
              class="cursor-pointer d-flex flex-row"
              v-b-modal.modal-delete
              @click="showModal(data.item.physicalCategoryId)"
            >
              <feather-icon size="20" icon="TrashIcon" class="text-danger" />
            </div>
          </template>

          <template #cell(edit)="data">
            <router-link
              v-if="data.item.type == 2"
              :to="{
                name: 'apps-categories-physical-editAPhysicalCategory',
                params: { id: data.item.physicalCategoryId },
              }"
              class="cursor-pointer d-flex flex-row"
            >
              <feather-icon size="20" icon="EditIcon" />
            </router-link>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
          </b-row>
        </div>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalCount"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                style="transform: rotate(180deg)"
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </div>
    <b-modal
      id="modal-delete"
      centered
      ok-title="حذف"
      cancelTitle="انصراف"
      @ok="deleteCategory(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import GuildsGetAll from "@/libs/Api/Guild/GuildGetAllRequest";
import GuildCreateRequest from "@/libs/Api/Guild/GuildCreateRequest";
import PhysicalCategoryDelete from "@/libs/Api/Categories/PhysicalCategories/DeleteAPhysicalCategory";
// import BlogCategoryCreateRequest from "@/libs/Api/Blog/ProductCategoryCreateRequest";
// import BlogCategoryDeleteRequest from "@/libs/Api/Blog/BlogCategoryDeleteRequest";

export default {
  name: "categories-list",
  title: "دسته بندی های فیزیکی - پنل ادمین فرادیدار",
  watch: {
    currentPage: function (nv, ov) {
      this.getAllGuilds(this.perPage, nv, this.searchQuery, this.perState);
    },
  },
  data() {
    return {
      guilds: null,
      totalCount: null,
      addNewCategory: false,
      deleteItem: null,
      currentPage: 1,
      perPage: 10,
      myTableColumns: [
        { key: "guildId", label: "شناسه" },
        { key: "name", label: "نام" },
        { key: "delete", label: "حذف" },
        { key: "edit", label: "ویرایش" },
      ],
      defaultCreateData: {
        name: null,
        // Type 1 is for default
        // Type 2 is for anything admins added
        type: 2,
      },
    };
  },
  async created() {
    await this.getAllGuilds();
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,

    vSelect,
  },
  methods: {
    async getAllGuilds() {
      let _this = this;

      let guildsGetAll = new GuildsGetAll(_this);
      guildsGetAll.setParams({
        pageNumber: _this.currentPage,
        count: 10,
      });
      await guildsGetAll.fetch(
        function (content) {
          _this.guilds = content.guilds;
          _this.totalCount = content.guildsCount;
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async createAGuild() {
      let _this = this;

      let guildCreateRequest = new GuildCreateRequest(_this);
      guildCreateRequest.setParams(_this.defaultCreateData);
      await guildCreateRequest.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `صنف جدید اضافه شد.`,
            },
          });
          _this.defaultCreateData.name = null;
          _this.getAllGuilds();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    async deleteCategory(param) {
      let _this = this;

      let physicalCategoryDelete = new PhysicalCategoryDelete(_this);
      physicalCategoryDelete.setId(param);
      await physicalCategoryDelete.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `دسته بندی جدید حذف شد.`,
            },
          });
          _this.getAllGuilds();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param;
    },
  },
};
</script>

<style scoped></style>
